import { render, staticRenderFns } from "./valmistumispyynnon-tarkistus.vue?vue&type=template&id=56850184&scoped=true&"
import script from "./valmistumispyynnon-tarkistus.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnon-tarkistus.vue?vue&type=script&lang=ts&"
import style0 from "./valmistumispyynnon-tarkistus.vue?vue&type=style&index=0&id=56850184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56850184",
  null
  
)

export default component.exports